import { render, staticRenderFns } from "./SetAutoRemoveDaysModal.vue?vue&type=template&id=489a00ae&scoped=true&"
import script from "./SetAutoRemoveDaysModal.vue?vue&type=script&lang=js&"
export * from "./SetAutoRemoveDaysModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a00ae",
  null
  
)

export default component.exports